import React, { useState } from 'react';
import { useMutation, useLazyQuery } from '@apollo/client';
import { Button, Dialog, DialogContent, DialogTitle, FormLabel, Grid, TextField } from "@material-ui/core";
import { List, ListItem, ListItemText } from "@material-ui/core";
import moment from 'moment';
import { DELETE_SHIP_BOX, RUN_SHIP_BOX, GET_SHIP_RUN_DETAILS } from './shipbox_gql';
import ShipItemList from "./ShipItemList";
import ShipRunDialog from "./ShipRunDialog";

export default function ShipBoxDialog(props) {
  const [detailsVisible, setDetailsVisible] = useState(false);

  const deleteShipBox = useMutation(DELETE_SHIP_BOX, {
    refetchQueries: [
      'GetShipBoxList'
    ], onCompleted: () => { props.setVisibleBox(null) }
  })[0];

  const runShipBox = useMutation(RUN_SHIP_BOX, {
    refetchQueries: [
      'GetShipBox'
    ]
  })[0];

  const [getShipRunDetails, { data: detailsData }] = useLazyQuery(GET_SHIP_RUN_DETAILS, {
    fetchPolicy: "network-only",
    onCompleted: () => { setDetailsVisible(true) }
  });

  const runBox = () => {
    if (window.confirm("Are you sure you want to run this box now?")) {
      runShipBox({ variables: { shipBoxId: props.shipBox.shipBoxId } })
        .then(({data: { runShipBox: { shipRunId }}}) =>
              window.alert("Enqueued job #" + shipRunId));
    }
  }

  const deleteBox = () => {
    if (window.confirm("Are you sure you want to delete this box?")) {
      deleteShipBox({ variables: { shipBoxId: props.shipBox.shipBoxId } });
    }
  }

  const showShipRunDetails = (shipRunId) => {
    getShipRunDetails({
      variables: { shipRunId: shipRunId }
    })
  }

  return (
    <React.Fragment>
      <Dialog 
        open={props.visible}
        onClose={() => props.setVisible(false)}
        fullWidth
        maxWidth="sm">
        <DialogTitle>Ship Box: {props.shipBox?.shipName}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField label="Name" disabled={true} value={props.shipBox?.shipName} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Date" disabled={true} value={moment(props.shipBox?.shipDate).format('MM/DD/YYYY')} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Extra" disabled={true} value={props.shipBox?.shipExtra} />
            </Grid>
            <Grid item xs={6}>
              <TextField label="Created By" disabled={true} value={props.shipBox?.createdBy} />
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Items</FormLabel>
              <ShipItemList shipBox={props.shipBox}/>
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Run History</FormLabel>
              <List dense={true} disablePadding={true}>
                {props.shipBox?.shipRuns.map(sr =>
                  <ListItem button key={sr.shipRunId} onClick={() => showShipRunDetails(sr.shipRunId)}>
                    <ListItemText primary={moment(sr.insertedAt).format("MM/DD/YYYY, h:m A")}/>
                  </ListItem>)}
              </List>
            </Grid>
            <Grid item xs={3}>
              <Button variant="outlined" onClick={runBox}>Run Now</Button>
            </Grid>
            <Grid item xs={4}>
              <Button variant="outlined" onClick={deleteBox}>Delete Box</Button>
            </Grid>
            <Grid item xs={2}>
              <Button variant="outlined" onClick={() => props.setVisible(false)}>Close</Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <ShipRunDialog shipRun={detailsData?.shipRunDetail} visible={detailsVisible} setVisible={setDetailsVisible}/>
    </React.Fragment>
  );
}
